module.exports = __webpack_public_path__ + "img/payment_failure_pc.5e3a8137.png";